import posthog from "posthog-js";
import { getTrackingConsent } from "@/hooks/useTrackingConsent";

// PostHog's own consent follows the cookie banner. posthog-js keeps it in
// localStorage (`__ph_opt_in_out_<token>`) and reads it on every capture, so
// the store's withdrawal cleanup keeps that key (useTrackingConsent.ts).

/**
 * A withdrawal of analytics consent (in the banner, or a lost accepted
 * cookie): opt out before the store clears PostHog's storage and reloads, so
 * nothing more is sent from this page, not even the reload's $pageleave, and
 * the stored "denied" keeps the next page load quiet too.
 */
export function stopPostHogOnWithdrawal(): void {
  if (!posthog.__loaded || getTrackingConsent().analytics) return;
  // Even if the opt-out key were lost, "no choice" now counts as opted out.
  posthog.set_config({ opt_out_capturing_by_default: true });
  if (posthog.get_explicit_consent_status() !== "denied") posthog.opt_out_capturing();
  posthog.set_config({ persistence: "memory" });
}

/** With analytics consent, undoes an earlier withdrawal's opt-out (no $opt_in event). */
export function resumePostHogWithConsent(): void {
  if (!posthog.__loaded || !getTrackingConsent().analytics) return;
  if (posthog.get_explicit_consent_status() === "denied" || posthog.config.opt_out_capturing_by_default) {
    posthog.set_config({ opt_out_capturing_by_default: false });
    posthog.opt_in_capturing({ captureEventName: false });
  }
}
